import { useEffect, useState } from "react";
import { navItems } from "@/mocks/site";
import {
  COMPANY_NAME,
  LINE_URL,
  LINE_COLOR,
  TEL_DISPLAY,
  TEL_HREF,
  FORM_ANCHOR,
  HOURS,
  HOLIDAY,
} from "@/constants";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      className={`sticky top-0 z-50 border-b border-background-200 transition-colors ${
        scrolled ? "bg-background-50/95 backdrop-blur" : "bg-background-50"
      }`}
    >
      <div className="hidden bg-primary-600 text-background-50 md:block">
        <div className="site-container flex items-center justify-between py-1.5 text-xs font-medium">
          <p className="whitespace-nowrap">埼玉県春日部市の不用品回収・遺品整理｜片付けからリフォームまで一社で対応</p>
          <p className="flex shrink-0 items-center gap-1.5 whitespace-nowrap">
            <i className="ri-time-line" />
            営業時間 {HOURS}／{HOLIDAY}
          </p>
        </div>
      </div>

      <div className="site-container flex items-center justify-between gap-4 py-3">
        <a href="#top" className="flex items-center">
          <span className="leading-tight">
            <span className="block whitespace-nowrap text-[10px] font-bold tracking-wide text-primary-700">
              春日部市の不用品回収・遺品整理
            </span>
            <span className="block whitespace-nowrap font-heading text-lg font-black text-foreground-900">{COMPANY_NAME}</span>
          </span>
        </a>

        <nav className="hidden items-center gap-4 xl:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm font-bold text-foreground-700 transition-colors hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href={TEL_HREF}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-3 py-2 transition-colors hover:bg-primary-100"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center">
              <i className="ri-phone-fill text-lg text-primary-600" />
            </span>
            <span className="flex items-baseline gap-1.5">
              <span className="text-xs font-bold text-foreground-600">電話で無料相談</span>
              <span className="font-heading text-base font-black text-primary-700">{TEL_DISPLAY}</span>
            </span>
          </a>
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: LINE_COLOR }}
            className="flex cursor-pointer items-center gap-2 rounded-md px-4 py-3 text-sm font-black text-white transition-all hover:brightness-95"
          >
            <i className="ri-line-fill text-lg" />
            <span className="whitespace-nowrap">LINEで相談</span>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="メニューを開閉"
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 xl:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 xl:hidden">
          <nav className="site-container flex flex-col py-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={close}
                className="border-b border-background-100 py-3 text-sm font-bold text-foreground-800"
              >
                {item.label}
              </a>
            ))}
            <div className="grid grid-cols-3 gap-2 py-4">
              <a
                href={TEL_HREF}
                className="flex flex-col items-center gap-1 rounded-md bg-primary-500 py-3 text-xs font-bold text-background-50"
              >
                <i className="ri-phone-fill text-lg" />
                電話する
              </a>
              <a
                href={LINE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: LINE_COLOR }}
                className="flex flex-col items-center gap-1 rounded-md py-3 text-xs font-bold text-white"
              >
                <i className="ri-line-fill text-lg" />
                LINEで相談
              </a>
              <a
                href={FORM_ANCHOR}
                onClick={close}
                className="flex flex-col items-center gap-1 rounded-md border border-primary-300 bg-primary-50 py-3 text-xs font-bold text-primary-700"
              >
                <i className="ri-mail-send-line text-lg" />
                フォーム
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}